import { render, staticRenderFns } from "./import-bookmarks.vue?vue&type=template&id=996da75e"
import script from "./import-bookmarks.vue?vue&type=script&lang=js"
export * from "./import-bookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports